import { createSelector } from '@ngrx/store';
import { BuyerState } from '../state';
import { getBuyerState } from '../feature-selector';

export const getCarouselState = createSelector(
  getBuyerState,
  (state: BuyerState) => state && state.carousel,
);
